import classes from './SearchField.module.css';

const SearchField = ({placeholder, styles, cssClass}) => {
	return (
		<input placeholder={placeholder} 
			   className={`${classes.element} ${cssClass}`} 
			   style={styles}/>
	);
};

export default SearchField;